import { useCallback, useState } from "react"

import { UOM_RENDER_PRECISION } from "@/constants/formats"
import { hasFloatPallets } from "@/utils/purchaseOrder"

interface UseRoundOffWarning {
  isVisible: boolean
  evaluate: (pallets: number | null | undefined) => void
  hide: () => void
}

export const useRoundOffWarning = (): UseRoundOffWarning => {
  const [isVisible, setIsVisible] = useState(false)

  const evaluate = useCallback((pallets: number | null | undefined) => {
    const normalized = Number((pallets ?? 0).toFixed(UOM_RENDER_PRECISION))
    setIsVisible(normalized > 0 && hasFloatPallets(normalized))
  }, [])

  const hide = useCallback(() => setIsVisible(false), [])

  return { isVisible, evaluate, hide }
}
